import { CloseOutlined } from '@ant-design/icons';
import { Button, Col, Input, Row, Form, Spin, notification } from 'antd';
import { useState } from 'react';
import { SEND_INVITE_STATUS } from '../../../constants/messages';
import { validateMessages } from '../../../constants/validation';
import { invite } from '../../../redux/actions/doctorAction';

const AddDoctorForm = ({ toggleAddDoctor }) => {
  const onFinish = (values) => {
    setLoading(true);
    let inviteValue = { email: values.email, data: { name: values.name } };

    invite(inviteValue)
      .then(() => {
        setLoading(false);
        toggleAddDoctor();
        notification.success({
          message: (SEND_INVITE_STATUS),
        });
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const [loading, setLoading] = useState(false);

  return (
    <Spin spinning={loading}>
      <div className="add-drawer-content">
        <Row justify="space-between">
          <Col className="drawer-title">Invite Doctor</Col>
          <Col>
            <CloseOutlined onClick={toggleAddDoctor} />
          </Col>
        </Row>
        <div className="add-drawer-form">
          <Form
            name="basic"
            layout="vertical"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            validateMessages={validateMessages}
          >
            
            <Form.Item
              label="Name"
              name="name"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input className="custom-input" />
            </Form.Item>
            <Form.Item
              label="Email"
              name="email"
              rules={[
                {
                  required: true,
                  type: 'email',
                },
              ]}
            >
              <Input className="custom-input" />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit" className="full-button">
                Send Invite
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </Spin>
  );
};
export default AddDoctorForm;
